module.exports = __webpack_public_path__ + "static/media/ico-meetup-created.6a2057c2.svg";